<template lang="pug">
  .auth-wrapper
    .auth

      router-link.logo(:to='{name: "blog"}')
        img( :src="LogoIcon" alt='AnyCurb' )

      .auth-preview
        img( src="@/assets/images/pictures/sign_in.jpg" alt="AnyCurb" )

      .auth-container
        slot

</template>

<script>
import LogoIcon from "@/assets/images/black-logo.png";
export default {
  name: "auth_layout",

  data() {
    return {};
  },

  computed: {
    LogoIcon() {
      return LogoIcon;
    },

    isSignIn() {
      return this.$route.name === "sign_in";
    },
  }
};
</script>

<style lang="scss" scoped>
.auth-wrapper {
  display: flex;
  width: 100%;
  height: 100vh;
}

.auth {
  position: relative;
  width: 100%;

  .logo {
    position: absolute;
    z-index: 40;
    top: 1.5rem;
    left: 1rem;
    filter: brightness(10);

    @include media-breakpoint-down(md) {
      left: 7.5rem;
    }

    img {
      @include media-breakpoint-down(sm) {
        // width: 76px;
      }
    }
  }
}

.login {
  position: absolute;
  top: 0.75rem;
  right: 0.75rem;

}

.auth-preview {
  position: relative;
  z-index: 1;
  overflow: hidden;
  height: 100vh;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
}

.auth-container {
  position: absolute;
  z-index: 10;
  top: 50%;
  left: 50%;
  width: 430px;
  max-height: 100vh;
  background: $white;
  overflow-y: auto;
  transform: translate(-50%, -50%);

  @include media-breakpoint-down(md) {
    overflow-y: visible;
  }
  @include media-breakpoint-down(sm) {
    width: 100%;
    min-height: 100vh;
    display: flex;
    align-items: center;
  }
}

/deep/ .auth-content {
  position: relative;
  display: flex;
  width: 100%;
  min-height: 100%;
  flex-direction: column;
  padding: 3rem;
  margin: 0 auto;

  @include media-breakpoint-down(sm) {
    padding: 2rem;
  }

  h1,
  h3 {
    margin-bottom: 2rem;
    font-size: 2rem;
    font-weight: 500;
    line-height: 37px;

    @include media-breakpoint-down(sm) {
      margin-bottom: 1.5rem;
      white-space: initial;
    }
  }

  p {
    span {
      color: $brand;
    }
  }

  .auth-social {
    display: flex;
    justify-content: space-between;

    .btn-social {
      min-width: 100%;

      @include media-breakpoint-down(md) {
        margin-top: 0;
      }
    }
  }

  .or {
    position: relative;
    margin: 1.5rem 0;
    text-align: center;

    @include media-breakpoint-down(sm) {
      margin: 1.25rem 0;
    }

    &::before,
    &::after {
      position: absolute;
      top: 45%;
      width: 45%;
      height: 1px;
      background: $gray-300;
      content: "";
    }

    &::before {
      left: 0;
    }

    &::after {
      right: 0;
    }
  }

  .custom-control {
    &-label {
      font-size: 0.875rem;
      font-weight: normal;
    }
  }
}
</style>
